import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { PageWithLayout } from '../containers/page';


import Dropzone from 'react-dropzone';
import GridLayout from 'react-grid-layout';

class GalleryPage extends Component {
    constructor(props) {
        super(props);
        this.onDrop = this.onDrop.bind(this);
        this.registerSocketIOEvents = this.registerSocketIOEvents.bind(this);
        this.updateGallery = this.updateGallery.bind(this);
        this.onLayoutChange = this.onLayoutChange.bind(this);
        this.setHome = this.setHome.bind(this);
        this.removeImage = this.removeImage.bind(this);
        this.changeSubTitle = this.changeSubTitle.bind(this);
        this.changeTitle = this.changeTitle.bind(this);

        this.dropzone = React.createRef()
        this.state = {
            files: [],
            homeImages: {},
            titles: {},
            subtitles: {},
            ids: {},
        };
    }



    componentDidMount() {
        this.props.handleLoader(true);

        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }


    }

    componentDidUpdate(prevProps) {
        if (this.props.socketIOClient) {
            this.registerSocketIOEvents();
        }
    }

    registerSocketIOEvents() {
        if (this.state._registeredEvents)
            return;

        this.setState({
            _registeredEvents: true
        });

        this.props.socketIOClient.on('updateGalleryImage', (data) => {
            if (data.successful) {
                this.props.handleLoader(null);

            }
        });

        this.props.socketIOClient.on('setGalleryImageHome', (data) => {
            if (data.successful) {
                this.props.socketIOClient.emit('gallery', {});

            }
        });

        this.props.socketIOClient.on('deleteGalleryImage', (data) => {
            if (data.successful) {
                this.props.socketIOClient.emit('gallery', {});

            }
        });


        

        this.props.socketIOClient.on('gallery', (data) => {
            this.props.handleLoader(null);

            console.log(data);
            this.setState({
                files: data.files,
                homeImages: data.homeImages,
                titles: data.titles,
                subtitles: data.subtitles,
                ids: data.ids,
            });
        });


        this.props.socketIOClient.emit('gallery', {});



    }

    componentWillUnmount() {
        if (!this.props.socketIOClient) return;
        this.props.socketIOClient.removeAllListeners("gallery");
    }

    setHome(idx) {

        if (!this.state.ids[idx]) {

            let homeImages = this.state.homeImages;
            homeImages[idx] = !homeImages[idx];
            this.setState({
                homeImages: homeImages
            });
        } else {
            this.props.handleLoader(true);
            this.props.socketIOClient.emit("setGalleryImageHome", { id: this.state.ids[idx], home: !this.state.homeImages[idx] });
        }
    }

    changeTitle(idx, val) {
        let titles = this.state.titles;
        titles[idx] = val;
        this.setState({
            titles: titles
        });

    }

    changeSubTitle(idx, val) {
        let titles = this.state.subtitles;
        titles[idx] = val;
        this.setState({
            subtitles: titles
        });

    }

    removeImage(idx) {

        if (!this.state.ids[idx]) {

            let files = this.state.files.slice(0, idx).concat(this.state.files.slice(idx + 1, this.state.files.length))
            let imagesLayout = this.state.imagesLayout.slice(0, idx).concat(this.state.imagesLayout.slice(idx + 1, this.state.imagesLayout.length))

            let homeImages = this.state.homeImages;
            delete homeImages[idx.toString()];

            this.setState({
                files: files,
                imagesLayout: imagesLayout,
                homeImages: homeImages
            });

        }else{
            this.props.handleLoader(true);
            this.props.socketIOClient.emit("deleteGalleryImage", { id: this.state.ids[idx] });
        }

    }


    updateGallery() {


        for (let i = 0; i < this.state.imagesLayout.length; i++) {
            var imageObj = {};
            imageObj.image = this.state.files[this.state.imagesLayout[i]];
            imageObj.home = this.state.homeImages[this.state.imagesLayout[i].toString()];
            imageObj.title = this.state.titles[this.state.imagesLayout[i].toString()];
            imageObj.subtitle = this.state.subtitles[this.state.imagesLayout[i].toString()];
            imageObj.id = this.state.ids[this.state.imagesLayout[i].toString()];
            imageObj.position = i;

            this.props.handleLoader(true);
            this.props.socketIOClient.emit("updateGalleryImage", imageObj);
            
            
        }

        //this.props.socketIOClient.emit("updateGallery", images);
    }




    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                let encoded = reader.result;
                resolve(encoded);
            };
            reader.onerror = error => reject(error);
        });
    }


    async onDrop(imageFiles) {

        let imagesLayout = [];
        let images = [];

        let titles = this.state.titles;
        let subtitles = this.state.subtitles;

        for (let i = 0; i < imageFiles.length; i++) {
            var base64Image = await this.getBase64(imageFiles[i]);
            images.push(base64Image);
            imagesLayout.push(i);
        }

        this.setState({
            files: this.state.files.concat(images),
            imagesLayout: imagesLayout,
            primaryImage: 0,
            titles,
            subtitles,
        });


        //console.log(imageFiles)
    }

    setPrimary(idx) {
        this.setState({
            primaryImage: idx
        });
    }


    onLayoutChange(layout) {
        //console.log(layout);
        let arr = [];
        for (let i = 0; i < layout.length; i++) {
            arr.push({ idx: layout[i].i, position: layout[i].y * 3 + layout[i].x });
        }

        arr.sort(function (a, b) { return (a.position > b.position) ? 1 : ((b.position > a.position) ? -1 : 0); });
        let imagesLayout = [];
        for (let i = 0; i < arr.length; i++) {
            imagesLayout.push(parseInt(arr[i].idx));
        }

        this.setState({
            imagesLayout: imagesLayout
        });

    }

    render() {

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };



        let images = [];
        let layouts = [];

        if (this.state.files) {
            let x = 0;
            let y = 0;
            for (let i = 0; i < this.state.files.length; i++) {
                let layout = { i: i.toString(), x: x, y: y, w: 1, h: 1, draggableHandle: ".drag-handle" };
                let propBag = { 'data-grid': layout }
                let item = {
                    content: (
                        <div className="image" key={i.toString()} data-grid={layout} >
                            <div className="image-wrap">
                                <img className="drag-handle" src={this.state.files[i]} />
                                <div className={this.state.homeImages[i.toString()] ? 'options primary' : 'options'}>
                                    <i className="mdi mdi-home" onClick={() => this.setHome(i)}></i>
                                    <i className="mdi mdi-delete" onClick={() => this.removeImage(i)}></i>
                                </div>

                                <div className="info">

                                    <input type="text" value={this.state.subtitles[i.toString()] ? this.state.subtitles[i.toString()] : ''} onChange={(e) => { console.log(e.target.value); this.changeSubTitle(i.toString(), e.target.value) }} placeholder={this.props.translate('Subtitle')} />
                                    <input type="text" value={this.state.titles[i.toString()] ? this.state.titles[i.toString()] : ''} onChange={(e) => this.changeTitle(i.toString(), e.target.value)} placeholder={this.props.translate('Title')} />
                                </div>
                            </div>
                        </div>
                    )
                };
                layouts.push(layout);
                images.push(item);
                x++;
                if (x >= this.dropzone.offsetWidth / 380) {
                    y++;
                    x = 0;
                }
            }



        }

        return (
            <div className="content">
                {

                    (!this.props.uData && !localStorage.uData) && <Redirect to='/login' />

                }
                <div className="panel ">
                    <div className="panel-title">
                        <h1>{this.props.translate('Gallery')}</h1>
                        <h6>{this.props.translate('Drag images to gallery')}</h6>

                    </div>

                    <div>



                        <div className="input-wrap">
                            <label>{this.props.translate('Upload images')}</label>
                            <div className="file-drop" ref={(ref) => this.dropzone = ref}>

                                <Dropzone
                                    onDrop={this.onDrop}
                                    className='dropzone'
                                    activeClassName='active-dropzone'
                                    multiple={true}>

                                    <button><i className="mdi mdi-file-outline"></i></button>




                                </Dropzone>


                                <GridLayout
                                    className="grid-layout gallery-grid"
                                    onLayoutChange={this.onLayoutChange}
                                    width={this.dropzone.offsetWidth}
                                    rowHeight={350}
                                    compactType={'horizontal'}
                                    isResizable={false}
                                    verticalCompact={true}
                                    draggableHandle={".drag-handle"}
                                    horizontalCompact={true}
                                    layout={layouts}
                                    useCSSTransforms={true}
                                    cols={this.dropzone.offsetWidth / 300}
                                >

                                    {
                                        images.map((image, idx) => {
                                            return (
                                                image.content
                                            );
                                        })
                                    }
                                </GridLayout>


                            </div>





                        </div>





                        <div className="input-wrap">
                            <button className="button" onClick={this.updateGallery}>{this.props.translate('Save')}</button>
                        </div>

                    </div>

                </div>

            </div>
        );
    }
}

export default PageWithLayout(GalleryPage);


// WEBPACK FOOTER //
// ./src/views/galleryPage.js